module.exports = __webpack_public_path__ + "img/code.f1244cdd.png";